import { useGetStatusListForSearch } from "@certa/queries/hooks/search.hooks";
import { PROCESS_STATUS } from "@certa/search/src/constants";
import React, { useMemo } from "react";
import { useDefinedProcessLabel } from "../../../../hooks/useDefinedProcessLabels";
import { useSearchStore } from "../../store/useSearchStore";
import { FilterDropdown } from "../FilterDropdown";
import { useGetObjectsStatuses } from "@certa/queries/hooks/dataObjects.hooks";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownSubMenu,
  DropdownSubMenuContent,
  DropdownSubMenuTrigger
} from "@certa/catalyst/components/Dropdown";
import { FilterTrigger } from "../FilterTrigger";
import { useIntl } from "react-intl";

export const StatusFilter: React.FC = () => {
  const intl = useIntl();

  const { data: processStatusList, isLoading: isLoadingProcessStatuses } =
    useGetStatusListForSearch();
  const processStatuses = processStatusList ? processStatusList : [];
  const { filters, setFilters } = useSearchStore();
  const { data: objectsStatuses, isLoading: isObjectStatusLoading } =
    useGetObjectsStatuses();

  const objectOptions = useMemo(() => {
    return (
      objectsStatuses?.map(status => ({
        label: status.name,
        value: status.id.toString()
      })) || []
    );
  }, [objectsStatuses]);

  const definedLabels = useDefinedProcessLabel();
  const statusLabel = definedLabels[PROCESS_STATUS];

  const options = processStatuses.map(status => ({
    label: status.label,
    value: status.value.toString()
  }));

  const numberOfAppliedWorkflowFilters = filters.statusIds.length || 0;
  const numberOfAppliedObjectFilters = filters.objectStatusIds.length || 0;
  const totalNumberOfAppliedFilters =
    numberOfAppliedWorkflowFilters + numberOfAppliedObjectFilters;

  const workflowLabel = intl.formatMessage({
    id: "globalSearch.statusFilter.workflowLabel",
    defaultMessage: "Workflows"
  });

  const dataRecordLabel = intl.formatMessage({
    id: "globalSearch.statusFilter.dataRecordLabel",
    defaultMessage: "Data Records"
  });

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger>
          <FilterTrigger
            label={statusLabel}
            extraText={
              totalNumberOfAppliedFilters > 0
                ? `(${totalNumberOfAppliedFilters})`
                : ""
            }
            isActive={totalNumberOfAppliedFilters > 0}
            maxWidth="11.25rem"
          />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownSubMenu>
            <DropdownSubMenuTrigger>{dataRecordLabel}</DropdownSubMenuTrigger>
            <DropdownSubMenuContent>
              <FilterDropdown
                label={statusLabel}
                options={objectOptions}
                selectedValues={filters.objectStatusIds}
                onChange={objectStatusIds => setFilters({ objectStatusIds })}
                areOptionsLoading={isObjectStatusLoading}
                statusType="data_record_status"
              />
            </DropdownSubMenuContent>
          </DropdownSubMenu>
          <DropdownSubMenu>
            <DropdownSubMenuTrigger>{workflowLabel}</DropdownSubMenuTrigger>
            <DropdownSubMenuContent>
              <FilterDropdown
                label={statusLabel}
                options={options}
                selectedValues={filters.statusIds}
                onChange={statusIds => setFilters({ statusIds })}
                areOptionsLoading={isLoadingProcessStatuses}
                statusType="workflow_status"
              />
            </DropdownSubMenuContent>
          </DropdownSubMenu>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
